<template>
  <div
    class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3"
  >
    <GeneralButton
      @click="startChat"
      :loading="creatingNewThread"
      :disabled="!courseData || creatingNewThread"
      >Start Chat</GeneralButton
    >
    <Teleport to="body">
      <PhoneNumberModal
        v-model:open="open"
        :loading="creatingNewThread"
        @check-customer="checkCustomer"
      ></PhoneNumberModal>
    </Teleport>
  </div>
</template>
<script setup lang="ts">
import * as uuid from "uuid";
import * as Sentry from "@sentry/nuxt";
import GeneralButton from "@/components/general/GeneralButton.vue";
import PhoneNumberModal from "@/components/PhoneNumberModal.vue";
import { useCourse } from "@/composables/course";
import { useGeneral } from "@/composables/general";
import { useRouter } from "vue-router";
import { useApiFetch } from "@/composables/fetch";
const { $clientPosthog } = useNuxtApp();
const { user, customer } = useFirebase();
const { useDefaultFetch } = useApiFetch();
const { courseData }: any = useCourse();
const router = useRouter();
const { sanitizeUriWithParams } = useGeneral();
const creatingNewThread = ref(false);
const open = ref(false);

const checkCustomer = async () => {
  console.log("Checking customer...");
  if (customer.value?.phoneNumber) {
    creatingNewThread.value = true;
    Sentry.addBreadcrumb({
      category: "check-customer",
      message: `Checking customer ${customer.value?.formattedPhoneNumber}`,
      level: "info",
      data: {
        customer: customer.value,
      },
    });
    let courseId = courseData.value?.courserevCourseId;
    if (courseData.value?.source_type === "mco") {
      courseId = courseData.value?.golfCourses?.[0]?.courserevCourseId;
    }
    const {
      execute: checkCustomerCall,
      data: checkCustomerResponse,
      isFetching: checkCustomerLoading,
      error: checkCustomerError,
    }: any = useDefaultFetch(
      `/chat/customer/${customer.value?.formattedPhoneNumber}/check`,
      {
        method: "POST",
        body: JSON.stringify({
          golfCoursePhoneNumber: courseData.value?.courserevGolfCoursePhoneNo,
          courseId,
          source_type: courseData.value?.source_type || "DEFAULT",
        }),
      }
    ).json();
    await checkCustomerCall();
    if (checkCustomerError.value) {
      const captureError = new ChatError(
        `Error checking customer ${customer.value?.formattedPhoneNumber}: ${checkCustomerError.value?.message}`,
        {
          phoneNumber: customer.value?.formattedPhoneNumber,
        },
        "Error checking customer"
      );
      Sentry.captureException(captureError);
    }
    if (checkCustomerResponse.value) {
      console.log("Customer exists: ", checkCustomerResponse.value);
      customer.value = {
        ...customer.value,
        ...checkCustomerResponse.value,
        userId: checkCustomerResponse.value?.customerId,
      };
      $clientPosthog?.identify(
        customer.value?.email || customer.value?.formattedPhoneNumber,
        {
          ...customer.value,
        }
      );
      Sentry.setUser({
        email: customer.value?.email,
        id: customer.value?.userId,
      });

      const newThreadId = `${uuid.v4()}`;
      creatingNewThread.value = false;
      router.push(sanitizeUriWithParams(`/chat/${newThreadId}`));
    }
  }
};
const startChat = async () => {
  console.log("Starting chat...");

  if (!customer.value?.phoneNumber) {
    open.value = true;
    return;
  }
  await checkCustomer();
};
onMounted(() => {
  Sentry.getCurrentScope().setTransactionName("StartChat");
});
</script>
